import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { map, every, some } from 'lodash';

import SelectableRecordTable from 'components/selectable_record_table/selectable_record_table';
import SelectionDetails from 'components/selection_details';
import LeasesTableHeader from './leases_table_header';
import LeaseRowContainer from './lease_row_container';

import {
  resetSelectedLeases,
  resetSelectedLeasesOnCurrentPage,
  toggleSelectAllLeases,
  toggleSelectAllLeasesOnCurrentPage
} from '../store/actions/select_list';

export class LeasesTable extends React.Component {
  static propTypes = {
    allLeaseIds: PropTypes.array.isRequired,
    leases: PropTypes.array.isRequired,
    resetSelection: PropTypes.func.isRequired,
    resetSelectionOnCurrentPage: PropTypes.func.isRequired,
    selectedLeaseIds: PropTypes.array.isRequired,
    toggleSelectAll: PropTypes.func.isRequired,
    toggleSelectAllOnCurrentPage: PropTypes.func.isRequired
  };

  allSelected() {
    return every(this.props.leases, lease => this.isSelected(lease.id)) && this.props.leases.length > 0;
  }

  someSelected() {
    return some(this.props.leases, lease => this.isSelected(lease.id)) && this.props.leases.length > 0;
  }

  isSelected(leaseId) {
    return this.props.selectedLeaseIds.indexOf(leaseId) > -1;
  }

  render() {
    const { resetSelectionOnCurrentPage, toggleSelectAllOnCurrentPage } = this.props;

    return (
      <SelectableRecordTable
        columnHeaders={<LeasesTableHeader />}
        selectAllChecked={this.allSelected()}
        selectNoneVisible={this.someSelected()}
        onResetSelection={resetSelectionOnCurrentPage}
        onSelectAllToggle={toggleSelectAllOnCurrentPage}
      >
        <SelectionDetails
          forTable
          label="lease"
          selectedCount={this.props.selectedLeaseIds.length}
          totalCount={this.props.allLeaseIds.length}
          onClearSelection={this.props.resetSelection}
          onSelectAll={this.props.toggleSelectAll}
        />
        {this.renderLeases()}
      </SelectableRecordTable>
    );
  }

  renderLeases() {
    const { leases } = this.props;
    return map(leases, lease => (
      <LeaseRowContainer
        key={lease.id}
        lease={lease}
        selected={this.isSelected(lease.id)}
      />
    ));
  }
}

const mapStateToProps = state => ({
  allLeaseIds: state.search.meta.compIds,
  leases: state.search.leases,
  selectedLeaseIds: state.selectList.selectedLeaseIds
});

const mapDispatchToProps = {
  resetSelection: resetSelectedLeases,
  resetSelectionOnCurrentPage: resetSelectedLeasesOnCurrentPage,
  toggleSelectAll: toggleSelectAllLeases,
  toggleSelectAllOnCurrentPage: toggleSelectAllLeasesOnCurrentPage
};

export default connect(mapStateToProps, mapDispatchToProps)(LeasesTable);
